export default __webpack_public_path__ + "images/2ab3feff0e20542b0afbe5e83b6947ba-fundraising_small.webp";